import styled from 'styled-components'
import { Box, Typography } from 'src/components'

export const OverContainerSection = styled(Box)`
    display: flex;
    justify-content: center;
    position: relative;
    align-items: center;
    flex-direction: column;
`
export const OverSection = styled(Box)`
    width: 96%;
    justify-content: center;
    align-items: start;
    display: flex;
    flex-direction: column;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 96%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 1200px;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }
`
export const OverContainer = styled(Box)`
    width: 98%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    display: flex;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 96%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 1200px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
`
export const TitleTypography = styled(Typography)`
    text-align: center;
    font-family: inherit;
    font-style: normal;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 1.4em;
        width: 70%;
    }
`
export const SectionCard = styled(Box)`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        flex-direction: row;
        display: flex;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const Destok = styled(Box)`
    display: none;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        display: none;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        display: flex;
    }
`
export const Mobil = styled(Box)`
    display: flex;
    width: 95%;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        display: flex;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        display: none;
    }
`
export const Refer = styled(Box)`
    cursor: pointer;
`
